import { authorizedUser } from "components/Common/commonFunctions";
import * as api from "../API/index";
import {
  customerList,
  customerServiceHistory,
  paymentTermList,
} from "../constants/customer";

export const getCustomerList = async (
  dispatch,
  { pageNum, filters = null, searchString = "" } = {},
) => {
  try {
    const res = await api.customer_list(pageNum, filters, searchString);
    dispatch({ type: customerList, payload: res.data });
  } catch (error) {
    dispatch({ type: customerList, payload: error?.response?.data || error });
    authorizedUser(error.response?.data);
  }
};

export const getCustomerById = async (id) => {
  try {
    const res = await api.get_customer_by_ID(id);
    return res.data;
  } catch (error) {
    return error?.response?.data || error;
  }
};

export const addCustomer = async (bodyData) => {
  try {
    const res = await api.add_customer(bodyData);
    return res.data;
  } catch (error) {
    authorizedUser(error.response?.data);
    return error?.response?.data || error;
  }
};

export const getPaymentTermList = async (dispatch) => {
  try {
    const res = await api.payment_term_list();
    dispatch({
      type: paymentTermList,
      payload: res.data,
    });
  } catch (error) {
    dispatch({
      type: paymentTermList,
      payload: error?.response?.data || error,
    });
    authorizedUser(error?.response?.data);
  }
};

export const editCustomer = async (id, bodyData) => {
  try {
    const res = await api.edit_customer(id, bodyData);
    return res.data;
  } catch (error) {
    return error?.response?.data || error;
  }
};

export const changeCustomerPassword = async (id, bodyData) => {
  try {
    const res = await api.change_customer_password(id, bodyData);
    return res.data;
  } catch (error) {
    return error.response?.data || error;
  }
};

export const getCustomerServiceList = async (dispatch, locationID, pageNum) => {
  try {
    const res = await api.getCustomerServiceHistory(locationID, pageNum);
    dispatch({ type: customerServiceHistory, payload: res.data });
  } catch (error) {
    dispatch({
      type: customerServiceHistory,
      payload: error?.response?.data || error,
    });
    authorizedUser(error.response?.data);
  }
};
